import type { InfractionText } from './types';

export const portInfractions: Record<string, InfractionText> = {
  HIGH_PORT_EXPOSED: {
    infraction: '{service} port exposed',
    explanation:
      'Port {port} is used for {service}, potentially exposing web content and application functionality.',
    whyRisk: 'Why is this a high risk?',
    risk: 'If {service} is not properly secured, unauthorised users may be able to access sensitive data, deface websites, or use the service as a launching point for further attacks.',
  },
  MEDIUM_PORT_EXPOSED: {
    infraction: '{service} ',
    explanation:
      'Port {port} is used for {service}, potentially exposing web content and application functionality.',
    risk: 'If {service} is not properly secured, unauthorised users may be able to access sensitive data, deface websites, or use the service as a launching point for further attacks.',
  },
  LOW_PORT_EXPOSED: {
    infraction: '{service} port exposed',
    explanation:
      'Port {port} is used for {service}, potentially exposing web content and application functionality.',
    risk: 'If {service} is not properly secured, unauthorised users may be able to access sensitive data, deface websites, or use the service as a launching point for further attacks.',
  },
};
